import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import useCartStore from '@/app/book/stores/useCartStore'

export interface UseClickIdProps {
  clickId?: string
}

export const useClickId = (): void => {
  const [setClickId, currentClickId] = useCartStore((state) => [state.setClickId, state.clickId])
  const searchParams = useSearchParams()
  const clickId = searchParams.get('click_id')
  useEffect(() => {
    if (clickId && currentClickId !== clickId) {
      setClickId(clickId)
    }
  }, [clickId, currentClickId, setClickId])
}
